enum InviteImageTypeEnum {
  HeroImage = 0,
  LogoImage = 1,
}

export default Object.freeze(InviteImageTypeEnum);
